// import { useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/analytics";
import { consola } from "consola";

type MenuComponent = {
  objectName: string;
  objectId: string;
};

type HyperlinkEvent = {
  objectName: string;
  hyperlink: string;
};

type SignoutEvent = {
  method: string;
};

type TabSwitchEvent = {
  pageName: string;
  tabName: string;
  lastTab: string;
};

type TextInputEvent = {
  pageName: string;
  textboxName: string;
  text: string;
};

type ButtonClickEvent = {
  buttonName: string;
  pageName: string;
  tabName: string;
};

type SubpageAccessEvent = {
  subpage: string;
  pageName: string;
  uid: string;
};

type MessageEvent = {
  clientId: string;
  groupId: string;
};

type DayClickEvent = {
  clientId: string;
  day: string;
};

const useEvents = () => {
  //   useEffect(() => {
  //     // Initialize Firebase analytics
  //     firebase.analytics();
  //   }, []);

  function logMenuComponent(event: MenuComponent) {
    const logString =
      "Clicked " + event.objectName + " Menu Button with id " + event.objectId;
    consola.log(logString);
    firebase.analytics().logEvent("clicked_menu_component", {
      ...event,
    });
  }

  function logHyperlink(event: HyperlinkEvent) {
    const logString = "Clicked " + event.objectName + " Hyperlink";
    consola.log(logString);
    firebase.analytics().logEvent("clicked_link", {
      ...event,
    });
  }

  function logSignout(event: SignoutEvent) {
    const logString = "User signed out with " + event.method;
    consola.log(logString);
    firebase.analytics().logEvent("signout", { ...event });
  }

  function logButtonClick(event: ButtonClickEvent) {
    const logString =
      "User clicked " +
      event.buttonName +
      " on the " +
      event.pageName +
      " page";
    consola.log(logString);
    firebase.analytics().logEvent("button_click", { ...event });
  }

  function logTabSwitch(event: TabSwitchEvent) {
    const logString = "User switched to " + event.tabName;
    consola.log(logString);
    firebase.analytics().logEvent("tab_switch", { ...event });
  }

  function logTextInput(event: TextInputEvent) {
    const logString = "User edited " + event.textboxName;
    consola.log(logString);
    firebase.analytics().logEvent("text_input", { ...event });
  }

  function logSubpageAccess(event: SubpageAccessEvent) {
    const logString = "User accessed " + event.pageName;
    consola.log(logString);
    firebase.analytics().logEvent("subpage_access", { ...event });
  }

  function logMessage(event: MessageEvent) {
    const logString = "User sent a message";
    consola.log(logString);
    firebase.analytics().logEvent("sent_message", { ...event });
  }

  function logDayClick(event: DayClickEvent) {
    const logString =
      "User selected " + event.day + " for client " + event.clientId;
    consola.log(logString);
    firebase.analytics().logEvent("sent_message", { ...event });
  }

  return {
    logMenuComponent,
    logHyperlink,
    logSignout,
    logButtonClick,
    logTabSwitch,
    logTextInput,
    logSubpageAccess,
    logMessage,
    logDayClick,
  };
};

export default useEvents;
